import type { Cache, ResolveInfo } from '@urql/exchange-graphcache';
import {
  EVENT_LIST_CACHE_FIELDS,
  ORGANIZATION_PEOPLE_CACHE_FIELDS,
} from '@/client/exchanges/cacheExchange/constants';
import { queueEventListReset } from '@/client/exchanges/cacheExchange/eventListResetQueue';
import invalidateFields from '@/client/exchanges/cacheExchange/invalidateFields';

export default function insert_event(
  parent: {
    insert_event?: {
      returning?: {
        datetime?: string | null;
        parent_id?: string | null;
      }[];
    } | null;
  },
  _args: unknown,
  cache: Cache,
  _info: ResolveInfo,
) {
  invalidateFields(
    [...EVENT_LIST_CACHE_FIELDS, ...ORGANIZATION_PEOPLE_CACHE_FIELDS],
    cache,
  );

  const firstInsertedEvent = parent.insert_event?.returning?.[0];
  queueEventListReset({
    datetime: firstInsertedEvent?.datetime,
    parentEventId: firstInsertedEvent?.parent_id,
  });
}
